import { render } from "./show-certificat.vue?vue&type=template&id=7ba370ff&scoped=true"
import script from "./show-certificat.vue?vue&type=script&lang=js"
export * from "./show-certificat.vue?vue&type=script&lang=js"

import "./show-certificat.vue?vue&type=style&index=0&id=7ba370ff&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba370ff"]])

export default __exports__